export default {
  setAttachmentCategoryIndex(state, attachmentCategoryIndex){
    state.attachmentCategoryIndex = attachmentCategoryIndex
  },
}
